export default __webpack_public_path__ + "static/media/contentbackground.a6750d68.jpg";